import React from 'react';
import SearchSelect from '../../components/SearchSelect';

// 复用的小组件 ----------------------------------------------------------------

export function RequiredMark({ required }: { required?: boolean }) {
    return required ? <span className="text-rose-500">* </span> : null;
}

export function NumInput({
    value,
    onChange,
    unit,
    disabled,
    step,
    className,
}: {
    value: number | string | undefined;
    onChange: (v: number) => void;
    unit?: string;
    disabled?: boolean;
    step?: number;
    className?: string;
}) {
    return (
        <div className="relative">
            <input
                className={`inp ${unit ? 'pr-10' : ''} ${disabled ? 'bg-slate-50' : ''} ${className || ''}`}
                type="number"
                step={step ?? 'any'}
                value={value ?? ''}
                disabled={disabled}
                onChange={(e) => onChange(Number(e.target.value))}
            />
            {unit && (
                <span className="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-slate-400">
                    {unit}
                </span>
            )}
        </div>
    );
}

export function Select<T extends string>({
    value,
    options,
    onChange,
    suffix,
    disabled,
}: {
    value: T;
    options: readonly T[] | T[];
    onChange: (v: T) => void;
    suffix?: string;
    disabled?: boolean;
}) {
    return (
        <div className="relative">
            <SearchSelect
                className="w-full"
                value={value}
                disabled={disabled}
                onChange={(v) => onChange(v as T)}
                options={options.map((o) => ({
                    value: String(o),
                    label: String(o),
                }))}
            />
            {suffix && (
                <span className="absolute right-7 top-1/2 -translate-y-1/2 text-xs text-slate-400">
                    {suffix}
                </span>
            )}
        </div>
    );
}



